export default __webpack_public_path__ + "static/media/paging_prev_disabled.e16fecae.svg";